import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import ENDPOINTS from "@/constants/endpoints"

export type ProcessorConfiguration = {
  id: string
  whiteLabelId: string
  paymentMethod: string
  processorId: string
  processor: {
    id: string
    name: string
  }
  createdAt: string
  updatedAt: string
}

type ProcessorConfigurationsResponse = {
  processorConfigurations: ProcessorConfiguration[]
}

export const useSmartRoutingProcessors = (
  paymentMethod?: string
) => {
  return useQuery({
    queryKey: ["smart-routing-processors", paymentMethod],
    queryFn: async () => {
      if (!paymentMethod) return []

      const { data } =
        await api.get<ProcessorConfigurationsResponse>(
          ENDPOINTS.SMART_ROUTING_PROCESSORS,
          {
            params: { paymentMethod },
          }
        )
      return data.processorConfigurations || []
    },
    enabled: !!paymentMethod,
    staleTime: 1000 * 60 * 5, // 5 minutos
  })
}
